<template>
  <div id="living" class="living" v-if="livingShow" ref="living">
    <div class="living-title">
      <h2>{{ title }}</h2>
      <div class="title-items">
        <ul>
          <li
            :class="{active: currentGrade === grade}"
            v-for="(grade, index) in gradeArr"
            :key="index"
            @click="checkItem(grade)"
          >{{ grade }}</li>
        </ul>
      </div>
    </div>
    <div
      class="living-content"
      v-show="currentGrade === grade"
      v-for="(grade, gradeIndex) in gradeArr"
      :key="gradeIndex"
    >
      <div
        class="living-content-item"
        v-for="(item, index) in livingDataArr[gradeIndex]"
        :key="index"
        @mouseenter="maskShow(index)"
        @mouseleave="maskHide(index)"
      >
        <transition name="fade">
          <div class="living-content-mask" v-show="currentLiving === index">
            <div class="target">
              {{ item.short_desc }}
            </div>
            <div class="btn"><a :href="item.url">立即报名</a></div>
          </div>
        </transition>
        <div class="item-img">
          <img :src="item.cover">
          <div class="time">
            <div class="time_L">共计{{Math.floor((item.end_time - item.begin_time) / 60 / 60)}}小时</div>
            <div class="time_R">{{`${getLocalTime(item.begin_time)}-${getLocalTime(item.end_time).substr(10, 16)}`}}</div>
          </div>
        </div>
        <div class="item-content">
          <p class="living-name">{{ item.course_name }}</p>
          <p class="price">
            <span class="actual-price">￥{{ item.actual_price }}</span>
            <span class="dividing-line">|</span>
            <span class="referee-price">{{ item.referee_price }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMiddleData } from 'js/getLivingData.js'
import Loading from '@/common-components/Loading'
export default {
  name: 'Featureliving',
  components: {
    Loading
  },
  props: ['title'],
  data () {
    return {
      currentGrade: '初中',
      livingDataArr: [],
      currentLiving: -1,
      livingShow: Boolean,
      gradeArr: ['初中', '高中']
    }
  },
  mounted () {
    this.getLivingData()
  },
  methods: {
    getLivingData () {
      let _this = this
      getMiddleData(53).then(function (res) {
        if (res.data.list.length >= 5) {
          res.data.list.length = 5
          _this.livingDataArr.push(res.data.list)
        } else {
          _this.livingShow = false
        }
      })
      getMiddleData(52).then(function (res) {
        if (res.data.list.length >= 5) {
          res.data.list.length = 5
          _this.livingDataArr.push(res.data.list)
        } else {
          _this.livingShow = false
        }
      })
    },
    checkItem (grade) {
      this.currentGrade = grade
    },
    maskShow (index) {
      this.currentLiving = index
    },
    maskHide (index) {
      this.currentLiving = -1
    }
  },
  computed: {
    getLocalTime (nS) {
      return function (nS) {
        return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.active
  border-left: 1px solid #c0e1a5
  border-right: 1px solid #c0e1a5
  border-top: 2px solid #62b31f
  background: #fff
  color: #62b31f
.living
  width: 1200px
  height: 244px
  margin: 18px auto
  display: flex
  flex-direction: column
  .living-title
    height: 40px
    line-height: 40px
    padding-left: 16px
    background-color: #f3f3f3
    border-bottom: 2px solid #c0e1a5
    display: flex
    h2
      font-size: 18px
      flex: 1
    .title-items
      flex: 4
      li
        padding: 0 20px
        font-size: 16px
        position: relative
        top: -2px
        height: 42px
        float: $fl
        cursor: pointer
  .living-content
    flex: 1
    display: flex
    margin-top: 10px
    justify-content: space-between
    .living-content-item
      width: 228px
      height: 192px
      font-size: 14px
      display: flex
      position: $rel
      flex-direction: column
      line-height: 20px
      float:left
      margin-right :12px\9\0
      .item-img
        flex: 6
        position: $rel
        img
          width: 100%
          height: 100%
        .time
          position: $abs
          width: 100%
          height: 24px
          line-height: 24px
          display: flex
          text-align: center
          font-size: 12px
          bottom: 0
          .time_L
            background: $livingTheme
            color: #fff
            display: flex
            flex: 2
            width: 76px
            justify-content: center
          .time_R
            background: rgba(98, 98, 97, .6)
            color: #fff
            display: flex
            flex: 5
            width: 152px
            ellipsis()
      .item-content
        flex: 2
        display: flex
        color: #3f3f3f
        flex-direction: column
        p
          flex: 1
          font-size: 14px
          ellipsis()
          justify-content: center
        .living-name
          font-size: 12px
          line-height: 28px
          color: #3f3f3f
        .price
          line-height: 24px
          .actual-price
            font-size: 14px
            display: inline-block
            color: #ff7011
          .dividing-line
            color: #dbdbdb
          .referee-price
            color: #bdbdbd
            font-size: 12px
            display: inline-block
            text-decoration: line-through
    .living-content-mask
      position: $abs
      display: flex
      top: 0
      bottom: 0
      left: 0
      right: 0
      z-index: 1
      color: #444
      background: #fff
      font-size: 12px
      justify-content: center
      align-items: center
      flex-direction: column
      box-shadow: 1px 1px 6px 1px #dbdbdb
      .target
        flex: 4
        width: 210px
      .btn
        flex: 1
        a
          width: 83px
          height: 24px
          line-height: 24px
          text-align: center
          color: #fff
          border-radius: 4px
          background: $livingTheme
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Living.vue